import { useEffect } from 'react';

interface KeyboardShortcutOptions {
    isExecuting: boolean;
    runtimeReady: boolean;
    isSaving: boolean;
    canEdit: boolean;
    isAuthenticated: boolean;
    executeCode: () => void;
    saveSketch: () => void;
}

export function useKeyboardShortcuts({
    isExecuting,
    runtimeReady,
    isSaving,
    canEdit,
    isAuthenticated,
    executeCode,
    saveSketch,
}: KeyboardShortcutOptions) {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.altKey && event.key === 'Enter') {
                event.preventDefault();
                if (!isExecuting && runtimeReady) {
                    executeCode();
                }
            }

            if ((event.ctrlKey || event.metaKey) && event.key === 's') {
                event.preventDefault();
                if (isAuthenticated && !isSaving && canEdit) {
                    saveSketch();
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isExecuting, runtimeReady, executeCode, isAuthenticated, isSaving, saveSketch, canEdit]);
}
